<div *ngIf="ADSearchComponent">
    <app-dci-filter [inputFields]="ADSearchComponentdata" (valueChange)='receviewData($event)'></app-dci-filter>
</div>
<div class="nav-container-2 view-container" [hidden]="selectedTabIndex==0">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
            <mat-tab-group (selectedTabChange)="viewTabClick($event)" [(selectedIndex)]="selectedTabIndex">
                <mat-tab label="" id="tabScheduleDoc"></mat-tab>
                <mat-tab *ngFor="let tab of viewDciTabList; let index = index" [label]="tab" class="tabsrow">
                    <ng-template mat-tab-label>
                        {{tab.doc_No}}
                        <i class="fa fa-times-circle ml-3" aria-hidden="true" (click)="closeViewTab(tab)"></i>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
<div class="nav-container-2 view-container" [hidden]="selectedWFActionTabIndex==0">
    <div class="row">
        <div *ngIf="!isBulkAction" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
            <mat-tab-group (selectedTabChange)="viewWFActionTabClick($event)" [(selectedIndex)]="selectedWFActionTabIndex">
                <mat-tab label="" id="tabScheduleDoc1"></mat-tab>
                <mat-tab *ngFor="let tab of viewWFActionTabList; let index = index" [label]="tab" class="tabsrow">
                    <ng-template mat-tab-label>
                        {{tab.documentNumber}}
                        <i class="fa fa-times-circle ml-3" aria-hidden="true" (click)="closeWFActionViewTab(tab)"></i>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
<div class="" *ngIf="(selectedTabIndex==0 && selectedWFActionTabIndex==0)">
    <div class="nav-container-1">
        <div class="row eip-px-xs-10">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 tab-container">
                <mat-tab-group [(selectedIndex)]="selectedRootIndex" (selectedTabChange)="tabClick($event)">
                    <mat-tab label="Pending Action">
                        <ng-template mat-tab-label id="lblChallanList">
                            Pending Action<span>{{pendingActionCount}}</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Action Taken ">
                        <ng-template mat-tab-label id="lblChallanList">
                            Action Taken<span>{{actionTakenCount}}</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="All">
                        <ng-template mat-tab-label id="lblChallanList">
                            All <span>{{totalCount}}</span>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-xs-12 icons-container">
                <mat-button-toggle-group #group="matButtonToggleGroup" style="width:100%" [(ngModel)]='buttonType' (change)="onValChange(group.value)">
                    <mat-button-toggle value="MyDocuments" style="width:100%;padding: 0%;">My Docs</mat-button-toggle>
                    <mat-button-toggle value="OtherDocuments" style="width:100%;padding: 0%;">Delegated Docs</mat-button-toggle>
                    <mat-button-toggle *ngIf="isAllworkflow" value="AllWorkflow" style="width:100%;padding: 0%;">All Workflow
                    </mat-button-toggle>
                </mat-button-toggle-group>
                <div class="icons-container d-flex justify-content-end">
                    <div class="d-none d-md-block">
                        <i class="fa fa-staff-template" aria-hidden="true" title="DTN Preparation" (click)="onClick_DTNPreparation()" *ngIf="(documentStatus == 1)"></i>
                        <i class="fa fa-share-o" aria-hidden="true" title="DTN Release" (click)="onClick_DTNRelease()" *ngIf="(documentStatus == 1) && (canCreate)"></i>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span style="color:#ddd;">&nbsp;&nbsp;|</span>
                        </div>
                        <i class="fa fa-re-edit" aria-hidden="true" title="Take Bulk Action" (click)="onClick_WorkflowAction(null,true)" *ngIf="documentStatus == 1"></i>
                        <div class="divider-container d-none d-md-block" id="imgDivider" *ngIf="isBulkApprove_enable">
                            <span style="color:#ddd;">&nbsp;&nbsp;|</span>
                        </div>
                        <i class="fa fa-check-circle-o" aria-hidden="true" title="Approve" (click)="onClick_WorkflowAction(null,false,true,false)" *ngIf="isBulkApprove_enable"></i>
                        <i class="fa fa-ban" aria-hidden="true" title="Revert" (click)="onClick_WorkflowAction(null,false,false,true)" *ngIf="isBulkApprove_enable"></i>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span style="color:#ddd;">&nbsp;&nbsp;|</span>
                        </div>
                        <i class="fa fa-search" title="Search" [ngClass]="{'active':isSearch}" aria-hidden="true" (click)="AdvanceSearch()" id="ibtSearch" aria-hidden="true" label="Advance Search"></i>
                        <i class="fa fa-question-circle" aria-hidden="true" title="Help Manual" (click)="HelpUrlClick()"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
            <kendo-grid #dciGrid [kendoGridBinding]="gridData" [height]="540" [pageable]="true" [pageSize]="pageSize" id="respondWorflowLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon" (selectionChange)="onSelectionChange($event)">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex">
                        <div class="flex-grow-1 title-container">
                            <p class="title">Details</p>
                            <div class="pagination-container details-section">
                                <p class="d-none d-sm-flex">- Viewing last</p>
                                <kendo-dropdownlist [data]='noOfDays' [value]="LastViewingRecords" (valueChange)="lastviewingrecordsmethod($event)" class="eip-mr-5 eip-ml-5" id="lblViewingLastDaysRecords" style="margin: 0px;"> </kendo-dropdownlist>
                                <p class="d-none d-sm-flex">days records</p>
                            </div>
                        </div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="pageSizes" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                <div class="icon-wrap">
                                    <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap">
                                    <span class="list-icon-name">Grid Settings</span>
                                </div>
                                <div class="icon-wrap" (click)="toggleFullscreen()">
                                    <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                    <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                </div>
                                <div class="icon-wrap">
                                    <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">&nbsp;&nbsp;Export to
                                        Excel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-checkbox-column showSelectAll="true" width="40"></kendo-grid-checkbox-column>
                <kendo-grid-column width="45">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <i aria-hidden="true" title="Attachment" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" (click)="viewAttachmentClick(dataItem)"></i>                       
                    </ng-template>                   
                </kendo-grid-column>
                <kendo-grid-column field="documentNumber" title="Document No" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span *ngIf="dataItem | enableWFActionIconPipe" class="no-wrap eip-link" style="cursor: pointer !important;" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto" (click)="onClick_WorkflowAction(dataItem.documentId,null,null,null,dataItem.assignedToId)" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.documentNumber}}</span>
                        <span *ngIf="dataItem | enableWFActionIconNpipe" class="no-wrap" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.documentNumber}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="documentNumber"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="documentTitle" title="Title" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap eip-link" style="cursor: pointer !important;" eipTooltip="{{dataItem.documentTitle}}" eipTooltipPosition="auto" (click)="viewDocumentClick(dataItem)" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.documentTitle}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="documentTitle"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="revisionNo" title="Revision" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="eip-link" (click)="openRevHistory($event,dataItem)" class="no-wrap eip-link" style="cursor: pointer !important;" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.revisionNo}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="revisionNo"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="discipline" title="Discipline" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.discipline}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="discipline"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="workflowDescription" title="Workflow Name" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflowDescription}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.workflowDescription}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="workflowDescription"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="subWorkflowName" title="Workflow Stage" width="100" id="GrlblStage">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.subWorkflowName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.subWorkflowName}}
                        </span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="subWorkflowName"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="taskName" title="Workflow Task" width="100" id="GrlblStatus">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.taskName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.taskName}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="taskName"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="integrationType" title="Integration Type" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.integrationType}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.integrationType}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="integrationType"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="message_Number" title="Transmittal Nos" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.message_Number}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">{{dataItem.message_Number}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="message_Number"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="assignedToName" title="Assigned To" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.assignedToName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.assignedToName}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="assignedToName"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="assignedOn" title="Assigned On" width="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.assignedOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.assignedOn| date:'dd-MMM-yyyy'}}
                        </span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-datepicker-filter [filter]="filter" field="assignedOn"></app-datepicker-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="completedByName" title="Completed By" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.completedByName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;"> 
                            {{dataItem.completedByName}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="gridData" Field="completedByName"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="completedOn" title="Completed On" width="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.completedOn| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.completedOn| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-datepicker-filter [filter]="filter" field="completedOn"></app-datepicker-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="action" title="" width="10" filter='false'>
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="floating-icon icon-container d-flex align-items-center">
                            <div *ngIf="buttonType=='AllWorkflow'">
                                <i *ngIf="dataItem | enableWFActionIconPipe:'reassign'" class="fa fa-delegated-access" aria-hidden="true" title="Re-Assign member" (click)="changeAssignedTo(dataItem)"></i>
                            </div>
                            <i *ngIf="dataItem | enableWFActionIconPipe" class="fa fa-re-edit" aria-hidden="true" title="Take Action" (click)="onClick_WorkflowAction(dataItem.documentId,null,null,null,dataItem.assignedToId)"></i>
                            <i class="fa fa-history" title="Workflow History" (click)="onClick_WorkflowHistory(dataItem)" aria-hidden="true"></i>
                        </div>
                    </ng-template>

                </kendo-grid-column>
                <kendo-grid-excel fileName="WorkflowList.xlsx" [fetchData]="allData"></kendo-grid-excel>
            </kendo-grid>
            <kendo-popup class="order-popup eip-ml-0" popupClass="kendo-popup kendo-popup-left doc-popup" [margin]="popupMargin" [anchor]="anchorElementPopup" [anchorAlign]="anchorAlignLeft" [popupAlign]="popupAlignLeft" style="width: 800px; z-index: 10002;box-shadow:none;" (anchorViewportLeave)="showRevHistory = false" *ngIf="showRevHistory" (click)="closeRevHistory()">
                <div class="kp-body">
                    <app-schedule-document-revision-history [inputModel]="revHistory">
                    </app-schedule-document-revision-history>
                </div>
            </kendo-popup>
        </div>
    </div>
</div>
<div *ngIf="selectedTabIndex!=0">
    <app-schedule-view [schDoc]="viewSchDoc"></app-schedule-view>
</div>
<div *ngIf="selectedWFActionTabIndex!=0">
    <ng-container *ngFor="let iviewWFAction of viewWFActionTabList">
        <app-respond-worflow-action [isBulkAction]="isBulkAction" [wfDetails]="iviewWFAction" (closeTab)="closeWFActionViewTab()" (CopyDetails)="CopyDetails($event)">
        </app-respond-worflow-action>
    </ng-container>
</div>
<div *ngIf="isBulkAction" class="bultActionButtonDias">
    <button type="button" class="btn btn-primary" (click)="BulkSubmit()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Submit</button>&nbsp;&nbsp;
    <button type="button" class="btn btn-secondary" (click)="closeWFActionViewTab()"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Cancel</button>
</div>